/**
 * Rôles. Ces trois valeurs sont celles de l'énumération PostgreSQL
 * user_role : aucune chaîne libre ne représente un rôle.
 *
 * Ces contrôles ne servent qu'à masquer des commandes. La vérification qui
 * fait autorité est celle du serveur, à l'entrée de chaque route.
 */
export const ROLES = ['lecture', 'technicien', 'administration'] as const;

export type Role = (typeof ROLES)[number];

const RANK: Record<Role, number> = {
  lecture: 0,
  technicien: 1,
  administration: 2,
};

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value);
}

/** Peut créer des postes, importer des diagnostics, écrire au journal. */
export function canWrite(role: Role): boolean {
  return RANK[role] >= RANK.technicien;
}

/** Peut gérer les utilisateurs et les salariés. */
export function canAdminister(role: Role): boolean {
  return RANK[role] >= RANK.administration;
}

export const ROLE_LABELS: Record<Role, string> = {
  lecture: 'Lecture',
  technicien: 'Technicien',
  administration: 'Administration',
};

export const ROLE_HINTS: Record<Role, string> = {
  lecture: "Consulte tout, n'écrit rien.",
  technicien: 'Crée des postes, importe des diagnostics, enregistre des événements.',
  administration: 'Tout cela, plus la gestion des utilisateurs et des salariés.',
};
